module.exports = __webpack_public_path__ + "img/sv112.ae2b86b4.svg";